var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "65%", "hide-close": true },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "d-md-flex justify-content-between" }, [
                _c("h4", { staticClass: "cursive" }, [
                  _vm._v("Completa il tuo preventivo!")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between d-md-block" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mx-1",
                        attrs: { id: "generaPreventivo" },
                        on: { click: _vm.onConfirm }
                      },
                      [_vm._v("\n          Completa\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary mx-1",
                        on: { click: _vm.onReset }
                      },
                      [_vm._v("\n          Annulla\n        ")]
                    )
                  ]
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "div",
              { staticClass: "border-top border-secondary py-1" },
              [_c("SummaryPreventivo")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2 border-top border-secondary pb-3" },
              [
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c(
                    "h6",
                    {
                      staticClass:
                        "text-uppercase mb-0 position-relative bg-white px-2",
                      staticStyle: { top: "-8px" }
                    },
                    [_vm._v("\n            Per persona\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c("h1", { staticClass: "text-uppercase mx-2 mb-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.totalePerPersona) +
                        " €\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mx-2 d-flex mt-2" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "mr-2",
                        staticStyle: { "line-height": "25px" }
                      },
                      [_vm._v("Totale")]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "default-bold" }, [
                      _vm._v(_vm._s(_vm.totale) + " €")
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bg-secondary text-white px-3 py-2 mb-1" },
              [
                _c("h5", { staticClass: "cursive mb-0" }, [
                  _vm._v(
                    "\n          Quota di gestione pratica e assicurazioni selezionate\n        "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.list, function(item, index) {
              return _c("SpesePanel", {
                key: index,
                staticClass: "mb-1",
                attrs: { index: index, value: item }
              })
            })
          ],
          2
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06658266", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06658266","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/modals/ModalSpesePratica.vue
// module id = null
// module chunks = 